import { render } from "./EffectsIcon.svg?vue&type=template&id=06eed4d3"
const script = {}
script.render = render

export default script